import { useEffect, useState } from "react";
import { can, get, put, loadSession } from "@/utils/service";
import { apiMessage, fieldErrors } from "@/utils/api";
import { notify } from "@/components/ui/dialogs";
import { Panel, Field, input, primary, secondary } from "@/pages/organization/shared";

export default function IncomeReportingSettings() {
  const editable = can("organization.update");
  const [date, setDate] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    get<{ data: { organization: { settings: { income_start_date?: string | null } | null } } }>("/organization")
      .then((r) => { setDate(r.data.organization.settings?.income_start_date ?? ""); setLoaded(true); })
      .catch((e) => notify(apiMessage(e, "Could not load income settings.")));
  }, []);
  const thisMonth = async () => {
    try {
      const r = await get<{ data: { organization: { timezone: string } } }>("/organization");
      const parts = new Intl.DateTimeFormat("en-US", { timeZone: r.data.organization.timezone, year: "numeric", month: "2-digit" }).formatToParts(new Date());
      setDate(`${parts.find((p) => p.type === "year")!.value}-${parts.find((p) => p.type === "month")!.value}-01`);
    } catch (e) { notify(apiMessage(e, "Could not select this month.")); }
  };
  const save = async () => {
    setBusy(true); setError("");
    try {
      await put("/organization", { settings: { income_start_date: date || null } });
      await loadSession();
      notify("Income reporting settings saved");
    } catch (e) {
      setError(fieldErrors(e)["settings.income_start_date"] ?? "");
      notify(apiMessage(e, "Could not save income settings."));
    } finally { setBusy(false); }
  };
  return <Panel title="Income reporting" description="Count income from payments received on or after your chosen date. Earlier payments remain recorded and continue to settle invoices.">
    <div className="max-w-xl space-y-4">
      <Field label="Income start date" hint="Leave empty to include all payment dates. Uses the actual receipt date, including advance payments." error={error}>
        <input type="date" className={input} disabled={!editable || !loaded || busy} value={date} onChange={(e) => setDate(e.target.value)} />
      </Field>
      {editable && <div className="flex flex-wrap gap-2">
        <button className={secondary} disabled={!loaded || busy} onClick={thisMonth}>Start from this month</button>
        <button className={secondary} disabled={!loaded || busy} onClick={() => setDate("")}>Include all history</button>
        <button className={primary} disabled={!loaded || busy} onClick={save}>{busy ? "Saving..." : "Save income settings"}</button>
      </div>}
    </div>
  </Panel>;
}
